export const cleanArray = arr => {
	return arr.filter(Boolean).filter((item, index, all) => (index === all.indexOf(item)))
}

export const equalArrays = (arr1, arr2) => (
	arr1.length === arr2.length &&
	arr1.sort().every((v, i) => v === arr2.sort()[i])
)
